module.exports = __webpack_public_path__ + "img/ダイハツ.bc303820.png";